// FieldTime Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Input from '../../common/input/input.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import Util from '../../../lib/util.jsx'
import classNames from 'classnames'

class FieldTime extends Component {
  constructor (props) {
    super(props)

    this.state = {
      bEdit: false,
      value: Util.convertMinutesToHour(props.value || 0),
      hasFocus: false
    }

    this._references = {
      time: React.createRef()
    }
  }

  static get propTypes () {
    return {
      value: PropTypes.string,
      className: PropTypes.string,
      showEdit: PropTypes.bool,
      onSave: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      value: '',
      className: '',
      showEdit: true,
      onSave: null,
      onChange: null,
      onFocus: null
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ value: Util.convertMinutesToHour(nextProps.value || 0) })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this.props.showEdit &&
      this.state.bEdit &&
      this.state.bEdit !== prevState.bEdit
    ) {
      if (this._references.time.current) {
        this._references.time.current.focus()
      }
    }
  }

  getValueInMintues () {
    const value = this.state.value || ''
    const parts = value.split(':')
    const hoursValue = parseInt(parts[0] || 0, 10) || 0
    const minsValue = parseInt(parts[1] || 0, 10) || 0
    return hoursValue * 60 + minsValue
  }

  focusInput () {
    setTimeout(() => {
      if (this._references.time.current) {
        this._references.time.current.focus()
      }
    })
  }

  render () {
    const { showEdit, onSave, className, ...others } = this.props
    const { bEdit, value, hasFocus } = this.state

    const _className = classNames(className, {
      hasfocus: hasFocus
    })

    return (
      <div
        className={`field field-time${
          showEdit && !bEdit ? ' disableedit' : ''
        }`}
      >
        <div className='fieldcontent'>
          <Input
            ref={this._references.time}
            styleType='fieldinput'
            {...others}
            onChange={this._onChange.bind(this)}
            onBlur={this._onBlur.bind(this)}
            onFocus={this._onFocus.bind(this)}
            className={_className}
            value={this._convertTime(value)}
          />
        </div>
        {showEdit &&
          (bEdit ? (
            <IconButton
              className='fieldaction'
              icon='done'
              type='primary'
              onClick={this._onSave.bind(this)}
            />
          ) : (
            <IconButton
              className='fieldaction'
              icon='edit'
              type='secondary'
              canHover
              onClick={this._onEnabledEdit.bind(this)}
            />
          ))}
      </div>
    )
  }

  /* Event Handlers */
  _onEnabledEdit () {
    this.setState({ bEdit: true })
  }

  _onChange (value) {
    if (value !== '' && /^[0-9]*$/.test(value)) {
      value = Util.convertMinutesToHour(parseFloat(value) * 60)
    }

    if (value === '' || this._validTimeText(value)) {
      this.setState({ value })
    }
  }

  _onSave (ev) {
    const value = this.state.value || ''
    if (this._validTimeText(value)) {
      this.setState({ bEdit: false })
      const minutes = this.getValueInMintues()

      if (this.props.onChange) {
        this.props.onChange(minutes, ev)
      }

      if (this.props.onSave) {
        this.props.onSave(ev)
      }
    }
  }

  _onFocus (ev) {
    if (this.props.onFocus !== undefined && this.props.onFocus) {
      this.props.onFocus(ev)
    }

    this.setState({ hasFocus: true })
  }

  _onBlur (ev) {
    this.setState({ hasFocus: false })
    this._onSave(ev)
  }

  _validTimeText (value) {
    return /^[0-9]{0,4}(:)*[0-9]{0,2}$/.test(value)
  }

  _convertTime (value) {
    if (!value || !this.state.hasFocus) {
      return value
    }

    return value.replace(':00', '')
  }
}

export default FieldTime
